import React from 'react';
import styles from "./ConfirmationPopup.module.scss";
import { ReactComponent as CrossIcon } from '../../../assets/images/global-icons/cross_ic.svg';
import {Button, Flex, Modal, Typography} from "antd";

interface ConfirmationPopupProps {
  isModalOpen: boolean;
  handleCancel: () => void;
  handleClick: () => void;
  text: string;
  removeText?: string;
}

const { Text } = Typography;

const ConfirmationPopup:React.FC<ConfirmationPopupProps> = ({isModalOpen, handleCancel, handleClick, text, removeText}) => {

  const handleRemoveClick = () => {
    handleClick();

    handleCancel();
  };

  return (
    <Modal
      className={styles.confirmationPopup}
      open={isModalOpen}
      onCancel={handleCancel}
      closable={false}
      footer={null}
      centered
    >
      <Flex vertical justify={'space-between'} className={styles.confirmationPopup__content}>
        <Flex vertical gap={'4px'} className={styles.confirmationPopup__content__header}>
          <Flex className={styles.confirmationPopup__content__header__content} justify={'space-between'}>
            <Text strong>Warning</Text>
            <CrossIcon color={'#2A2D31'} onClick={handleCancel} />
          </Flex>
          <p>{text}</p>
        </Flex>
        <Flex className={styles.confirmationPopup__content__buttons} gap={'4px'}>
          <Button onClick={handleCancel} type="text">
            Cancel
          </Button>
          <Button onClick={handleRemoveClick} type="text">
            {removeText ? removeText : 'Delete'}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConfirmationPopup;